import client from '../base-api';

const serviceURL = '/dropdown';

const dropdownService = {


    // USER -------------------------------------
    getUsers() {
        return client.get(`${serviceURL}/user`);
    },
    getUsersForLocation(locationId: number) {
        return client.get(`${serviceURL}/user-for-location/${locationId}`);
    },
    getCoach(filterData: any) {
        return client.get(`${serviceURL}/coach`, {params: filterData});
    },
    getSocioTherapistByLocation(locationId: number) {
        return client.get(`${serviceURL}/user-socio-therapist/${locationId}`);
    },
    getUsersForPrivateCoaching(locationId: number) {
        return client.get(`${serviceURL}/user-private-coaching/${locationId}`);
    },
    getUsersAssistedLivingCoaching(locationId: number) {
        return client.get(`${serviceURL}/user-assisted-living-coaching/${locationId}`);
    },
    getUsersCaseManagementCoaching(locationId: number) {
        return client.get(`${serviceURL}/user-case-management-coaching/${locationId}`);
    },
    getUsersForHrOverview() {
        return client.get(`${serviceURL}/user-hr-overview`);
    },
    getUsersForCoordinatorOverview(includeHimSelf = 'false') {
        return client.get(`${serviceURL}/user-coordinator-overview/${includeHimSelf}`);
    },
    getCoordinatorForOfficeAudit(locationId: number) {
        return client.get(`${serviceURL}/audit/coordinator/${locationId}`);
    },
    getTravelExpensesUsersForCoordinator() {
        return client.get(`${serviceURL}/travel-expenses/users-for-coordinator`);
    },
    getExternalCoach() {
        return client.get(`${serviceURL}/extern-coach`);
    },
    getExternalCoachForBilling() {
        return client.get(`${serviceURL}/extern-coach-for-billing`);
    },
    getExternalCoachForCoordinator() {
        return client.get(`${serviceURL}/extern-coach-for-coordinator`);
    },
    getCoachDropdownForAnalytics() {
        return client.get(`${serviceURL}/coach-for-analytics`);
    },
    getContactsForPotentialUnemployed() {
        return client.get(`${serviceURL}/contact-persons-for-potential-unemployed`);
    },
    getCoachesForInquiryAccept(inquiryId: number) {
        return client.get(`${serviceURL}/coaches-for-inquiry-accept/${inquiryId}`);
    },
    getInternalCoordinator() {
        return client.get(`${serviceURL}/internal-coordinator`);
    },
    getExternalCoordinator() {
        return client.get(`${serviceURL}/external-coordinator`);
    },


    // OFFICE ------------------------------------
    // By default only active offices, pass {allStatuses: '1'} to get pending/closed too
    getOffices(params: Record<string, string> = {}) {
        return client.get(`${serviceURL}/office`, {params});
    },
    getOfficesByUserRole() {
        return client.get(`${serviceURL}/office-by-user-role`);
    },

    // YEAR ------------------------------------
    getYear() {
        return client.get(`${serviceURL}/year`);
    },

    // CLIENT ------------------------------------
    getClients() {
        return client.get(`${serviceURL}/client`);
    },
    getClientsByLocation(locationId: number) {
        return client.get(`${serviceURL}/client-by-location/${locationId}`);
    },
    getClientsForCaseManagementCoaching() {
        return client.get(`${serviceURL}/client-for-case-management-coaching`);
    },

    // COACH -------------------
    getCoachingType() {
        return client.get(`${serviceURL}/coaching-type`);
    },


    // COURSE PRIVATE COACHING -------------------
    getCoursePrivateCoaching(locationId = "") {
        return client.get(`${serviceURL}/course/private-coaching/${locationId}`);
    },
    getCoursePrivateCoachingClients(courseId: number) {
        return client.get(`${serviceURL}/course/private-coaching-clients/${courseId}`);
    },
    getCoursePrivateCoachingModule(operationType: string) {
        if (operationType == 'modular_integration_coaching') {
            return client.get(`${serviceURL}/course/private-coaching/module/mic`);
        }
        if (operationType == 'go_work_mobile') {
            return client.get(`${serviceURL}/course/private-coaching/module/go-work-mobile`);
        }

        return [];
    },


    // COURSE GROUP COACHING ----------------------
    getCourseGroupCoaching(locationId = '') {
        return client.get(`${serviceURL}/course/group-coaching/${locationId}`);
    },
    getCourseGroupCoachingClients(courseId: number) {
        return client.get(`${serviceURL}/course/group-coaching-clients/${courseId}`);
    },


    // COURSE PRIVATE LEARNING COACHING -----------
    getCoursePrivateLearningCoaching(locationId = "") {
        return client.get(`${serviceURL}/course/private-learning-coaching/${locationId}`);
    },
    getCoursePrivateLearningCoachingModule() {
        return client.get(`${serviceURL}/course/private-learning-coaching/module`);
    },


    // UNEMPLOYED ----------------------------------
    getAllUnemployed(filterData: any) {
        return client.get(`${serviceURL}/unemployed`, {params: filterData});
    },
    getNewAndActiveUnemployed(filterData: any) {
        return client.get(`${serviceURL}/unemployed/new-and-active`, {params: filterData});
    },
    getFinishedUnemployed(filterData: any) {
        return client.get(`${serviceURL}/unemployed/finished`,  {params: filterData});
    },
    getPotentialUnemployed() {
        return client.get(`${serviceURL}/unemployed/potential`);
    },
    getPrivateCoachingDigitalDocuments(unemployedId: number) {
        return client.get(`${serviceURL}/unemployed/private-coaching-digital-documents/${unemployedId}`);
    },
    getPrivateCoachingByUnemployed(unemployedId: number) {
        return client.get(`${serviceURL}/unemployed/private-coaching/${unemployedId}`);
    },



    // ADDRESS BOOK --------------------------------
    getAddressBookDoctor() {
        return client.get(`${serviceURL}/address-book-doctor`);
    },


    // PROVINCE ------------------------------------
    getProvince() {
        return client.get(`${serviceURL}/province`);
    },


    // PRIVATE COACHING
    getPrivateCoachingAssignedCoaches(id: number) {
        return client.get(`${serviceURL}/private-coaching/assigned-coaches/${id}`);
    },
    getPrivateCoachingAssignedModules(id: number) {
        return client.get(`${serviceURL}/private-coaching/assigned-modules/${id}`);
    },
    getFinishedPrivateCoaching() {
        return client.get(`${serviceURL}/private-coaching/finished`);
    },
    getArchivedPrivateCoaching(filterData: any) {
        return client.get(`${serviceURL}/private-coaching/archived`, {params: filterData});
    },


    // GROUP COACHING
    getGroupCoachingAssignedCoaches(id: number) {
        return client.get(`${serviceURL}/group-coaching/assigned-coaches/${id}`);
    },
    getFinishedGroupCoaching() {
        return client.get(`${serviceURL}/group-coaching/finished`);
    },
    getArchivedGroupCoaching() {
        return client.get(`${serviceURL}/group-coaching/archived`);
    },


    // ASSISTED LIVING COACHING
    getAssistedLivingCoachingAssignedCoaches(id: number) {
        return client.get(`${serviceURL}/assisted-living-coaching/assigned-coaches/${id}`);
    },
    getNewAndActiveAssistedLivingCoaching(termin: string, excludeCoachingId: string) {
        return client.get(`${serviceURL}/assisted-living-coaching/new-and-active/${termin}/${excludeCoachingId}`);
    },
    getFinishedAssistedLivingCoaching() {
        return client.get(`${serviceURL}/assisted-living-coaching/finished`);
    },
    getArchivedAssistedLivingCoaching() {
        return client.get(`${serviceURL}/assisted-living-coaching/archived`);
    },

    // CASE MANAGEMENT COACHING
    getCaseManagementCoachingAssignedCoaches(id: number) {
        return client.get(`${serviceURL}/case-management-coaching/assigned-coaches/${id}`);
    },
    getFinishedCaseManagementCoaching() {
        return client.get(`${serviceURL}/case-management-coaching/finished`);
    },
    getArchivedCaseManagementCoaching() {
        return client.get(`${serviceURL}/case-management-coaching/archived`);
    },

    // PRIVATE LEARNING COACHING
    getPrivateLearningCoachingAssignedModules(id: number) {
        return client.get(`${serviceURL}/private-learning-coaching/assigned-modules/${id}`);
    },
    getFinishedPrivateLearningCoaching() {
        return client.get(`${serviceURL}/private-learning-coaching/finished`);
    },
    getArchivedPrivateLearningCoaching() {
        return client.get(`${serviceURL}/private-learning-coaching/archived`);
    },


    // SOCIO THERAPY COACHING
    getFinishedSocioTherapyCoaching() {
        return client.get(`${serviceURL}/socio-therapy-coaching/finished`);
    },
    getArchivedSocioTherapyCoaching() {
        return client.get(`${serviceURL}/socio-therapy-coaching/archived`);
    },


}


export default dropdownService;


